import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div data-testid="terms-page" className="min-h-screen bg-background page-with-nav">
      <div className="sticky top-0 z-30 bg-background/95 backdrop-blur-sm border-b-2 border-border px-4 py-3 flex items-center gap-3">
        <button data-testid="terms-back-btn" onClick={() => navigate(-1)} className="min-w-[44px] min-h-[44px] flex items-center justify-center">
          <ArrowLeft className="w-6 h-6 text-foreground" />
        </button>
        <span className="font-heading text-lg text-primary uppercase">Terminos</span>
      </div>

      <div className="max-w-2xl mx-auto px-5 py-8 space-y-8">
        <div>
          <h1 className="font-heading text-3xl text-primary uppercase leading-tight">Terminos y Condiciones de Uso</h1>
          <div className="border-t-4 border-primary w-16 mt-3" />
        </div>

        <p className="text-foreground/80 font-body text-sm leading-relaxed">
          Bienvenido a <strong className="text-primary">Bisne</strong> ("El Marketplace de la Raza"). Al usar nuestra aplicacion, aceptas los siguientes terminos y condiciones. Si no estas de acuerdo, por favor no utilices la plataforma.
        </p>

        {/* Seccion 1 */}
        <section className="space-y-3">
          <h2 className="font-heading text-xl text-foreground uppercase">1. Naturaleza del Servicio</h2>
          <p className="text-muted-foreground font-body text-sm leading-relaxed">
            Bisne es unicamente una <strong className="text-foreground">plataforma de intermediacion</strong> (un tablero de anuncios digital). Conectamos a compradores y vendedores para facilitar el intercambio de productos y servicios.
          </p>
          <ul className="text-muted-foreground font-body text-sm leading-relaxed space-y-2 pl-4">
            <li className="flex gap-2"><span className="text-primary font-bold shrink-0">-</span>No somos duenos de los articulos publicados.</li>
            <li className="flex gap-2"><span className="text-primary font-bold shrink-0">-</span>No revisamos ni garantizamos la calidad, autenticidad o estado de los productos.</li>
            <li className="flex gap-2"><span className="text-primary font-bold shrink-0">-</span>No participamos en la transaccion final entre comprador y vendedor.</li>
          </ul>
        </section>

        {/* Seccion 2 */}
        <section className="space-y-3">
          <h2 className="font-heading text-xl text-foreground uppercase">2. Entregas y Responsabilidad</h2>
          <div className="border-2 border-primary/40 bg-primary/5 p-4 rounded-sm">
            <p className="text-foreground font-body text-sm leading-relaxed font-semibold">
              Las entregas, puntos de reunion, metodos de envio y el intercambio fisico de los productos o dinero son responsabilidad 100% y exclusiva de los usuarios (comprador y vendedor).
            </p>
          </div>
          <p className="text-muted-foreground font-body text-sm leading-relaxed">
            Bisne no ofrece servicios de paqueteria, no retiene fondos y no se hace responsable por robos, fraudes, productos defectuosos o incidentes durante la entrega.
          </p>
          <div className="bg-zinc-800/50 border border-zinc-700 p-3 rounded-sm">
            <p className="text-primary font-body text-xs font-bold uppercase tracking-wider">Recomendacion de seguridad</p>
            <p className="text-muted-foreground font-body text-sm mt-1">Siempre verse en lugares publicos y seguros. De preferencia, lleva a alguien de confianza contigo.</p>
          </div>
        </section>

        {/* Seccion 3 */}
        <section className="space-y-3">
          <h2 className="font-heading text-xl text-foreground uppercase">3. Reglas de la Comunidad</h2>
          <p className="text-muted-foreground font-body text-sm leading-relaxed">
            Queda estrictamente prohibida la publicacion de:
          </p>
          <ul className="text-muted-foreground font-body text-sm leading-relaxed space-y-2 pl-4">
            <li className="flex gap-2"><span className="text-red-400 font-bold shrink-0">-</span>Articulos ilegales, robados o de procedencia dudosa.</li>
            <li className="flex gap-2"><span className="text-red-400 font-bold shrink-0">-</span>Armas de fuego, armas blancas o explosivos.</li>
            <li className="flex gap-2"><span className="text-red-400 font-bold shrink-0">-</span>Drogas, sustancias controladas o farmacos sin receta.</li>
            <li className="flex gap-2"><span className="text-red-400 font-bold shrink-0">-</span>Contenido que promueva violencia, discriminacion u odio.</li>
          </ul>
          <p className="text-muted-foreground font-body text-sm leading-relaxed">
            Nos reservamos el derecho de <strong className="text-foreground">eliminar publicaciones y banear usuarios</strong> que violen estas reglas sin previo aviso.
          </p>
        </section>

        {/* Seccion 4 */}
        <section className="space-y-3">
          <h2 className="font-heading text-xl text-foreground uppercase">4. Modificaciones</h2>
          <p className="text-muted-foreground font-body text-sm leading-relaxed">
            Nos reservamos el derecho de modificar estos terminos en cualquier momento. El uso continuado de la plataforma despues de los cambios constituye la aceptacion de los mismos.
          </p>
        </section>

        <div className="border-t border-border pt-4">
          <p className="text-muted-foreground/50 font-body text-xs text-center">Ultima actualizacion: Febrero 2026</p>
        </div>
      </div>
    </div>
  );
}
